import { createClient } from "./httpClientFactory"
import ResponseTransformer from "@/transformers/response.transformer"
import { getConfig } from "@/services/abstract.service.js"

export function getSuccessHandler({ transformer = null, transformerMethod }) {
  if (transformer) {
    return (res) => {
      if (transformerMethod) {
        if (res.data["hydra:member"] && res.data["hydra:totalItems"] >= 0) {
          let items = transformer[transformerMethod](res.data["hydra:member"])
          let totalItems = res.data["hydra:totalItems"]
          return { items, totalItems }
        }

        return transformer[transformerMethod](res.data)
      }

      return transformer["fetch"](res.data)
    }
  }

  return (res) => {
    return Promise.resolve(res.data)
  }
}

/**
 * Gets the error handler based on the transformer existence.
 */
export function getErrorHandler(error, { transformer = null } = {}) {
  if (transformer && transformer.error) {
    return Promise.reject(transformer["error"](error))
  }

  return Promise.reject(ResponseTransformer.error(error))
}

/**
 * Merges default options with custom ones.
 *
 * @param {Object} options Custom options
 * @returns The merged options object
 */
export function mergeOptions(options) {
  return {
    needsAuth: false,
    contentType: "json",
    ...options,
    config: getConfig(options)
  }
}

class HttpClientService {
  constructor({ baseUri, transformer, methodWithoutAuth }) {
    this.transformer = transformer
    this.baseUri = baseUri
    this.transformer = transformer
    this.methodWithoutAuth = methodWithoutAuth
    this.httpClient = createClient(import.meta.env.VITE_API_SERVER_URL)
  }

  post(url, options) {
    options = mergeOptions(options)

    return this.httpClient
      .post(url, options.payload, options.config)
      .then(getSuccessHandler(options))
      .catch((error) => getErrorHandler(error, options))
  }

  getCollection(customUrl, options = {}) {
    let url = customUrl ?? this.baseUri
    options = mergeOptions({
      transformer: this.transformer,
      transformerMethod: this.transformer ? "receiveCollection" : null,
      needsAuth: this.methodWithoutAuth
        ? typeof this.methodWithoutAuth === "string" && this.methodWithoutAuth === "all"
          ? false
          : !this.methodWithoutAuth.includes("getCollection")
        : true,
      ...options
    })

    if (options.queryString) {
      url = `${url}?${options.queryString}`
    }

    return this.httpClient
      .get(url, options.config)
      .then(getSuccessHandler(options))
      .catch((error) => getErrorHandler(error, options))
  }
}

export default HttpClientService
